import Head from 'next/head';
import { forwardRef } from 'react';

import type { BoxProps } from '@mui/material';
import type { ReactNode } from 'react';

const PAGE_TITLE: string = process.env.NEXT_PUBLIC_PAGE_TITLE ?? '';

export interface PageProps extends BoxProps {
  children: ReactNode;
  meta?: ReactNode;
  title: string;
}

/**
 * A Wrapper adding a Next Head in scope <br>
 * handling the Pages Mata Data <br>
 * by default tye title prop is provided by the env variable `NEXT_PUBLIC_PAGE_TITLE`
 * @deprecated for next app[lang] router due to first class support for meta-date <https://nextjs.org/docs/app/building-your-application/optimizing/metadata>
 */
export const Page = forwardRef<HTMLDivElement, PageProps>( function Page(
  { children, meta, title, ...props },
  ref
) {
  return (
    <>
      <Head>
        <title>
          {`${title} | ${PAGE_TITLE}`}
        </title>
        {meta}
      </Head>

      {children}
    </>
  );
} );
